import { handleError } from "../../utils/Common/Constant";
import apiClient from "../Connection/Connection";
export const getUserNotifications = async (
  currentPage: number,
  pageSize: number,
) => {
  try {
    const res = await apiClient.get(
      `/notification/userNotifications?currentPage=${currentPage}&pageSize=${pageSize}&type=push`,
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// get notification count
export const getNotificationCount = async () => {
  try {
    const res = await apiClient.get(
      "/notification/notificationCount?isSeen=false",
    );
    return res?.data;
  } catch (error) {
    handleError(error);
  }
};

// mark as seen
export const markAsSeenNotification = async (data: any) => {
  try {
    const res = await apiClient.put("/notification/seenNotification", data);
    return res.data;
  } catch (error) {
    handleError(error);
  }
};
